export const fileRules = (t) => [
  {
    required: true,
    message: t('translation:default.documentManager.chooseFileMessage'),
  },
];

export const docTypeCodeRules = (t) => [
  {
    required: true,
    message: t('translation:default.documentManager.documentManager.message'),
  },
];
